import { fileApi } from '@/api'
import { fileTypeId } from '@/scripts/consts'

export const filesForWork = {
  data() {
    return {
      linkFileList: [],
      agreementFileList: [],
      deletedFilesForApi: []
    }
  },

  methods: {
    uploadLinkFiles(files) {
      for (const file of files) {
        this.linkFileList.push(file)
      }
    },

    uploadAgreementFile(file) {
      this.agreementFileList = [file]
    },

    removeLinkFile(index) {
      const deletedFile = this.linkFileList.splice(index, 1)[0]
      if (deletedFile.id) this.deletedFilesForApi.push(deletedFile)
    },

    removeAgreementFile(index) {
      const deletedFile = this.agreementFileList.splice(index, 1)[0]
      if (deletedFile.id) this.deletedFilesForApi.push(deletedFile)
    },

    async getFileList(commonWorkId) {
      try {
        const fileList = await fileApi.getFileList(commonWorkId)
        this.linkFileList = fileList.filter(file => file.fileType.id === fileTypeId.link)
        this.agreementFileList = fileList.filter(file => file.fileType.id === fileTypeId.agreement)
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить файлы')
      }
    },

    async saveFile(commonWorkId, fileList, fileTypeIdValue) {
      try {
        const savedFiles = (await fileApi.postFiles(commonWorkId, fileTypeIdValue, fileList)) || []

        if (fileTypeIdValue === fileTypeId.link) {
          this.linkFileList = this.linkFileList.filter(linkFile => Boolean(linkFile.id))
          this.linkFileList.push(...savedFiles)
        }

        if (fileTypeIdValue === fileTypeId.agreement) {
          this.agreementFileList = this.agreementFileList.filter(agreementFile => Boolean(agreementFile.id))
          this.agreementFileList.push(...savedFiles)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось сохранить файлы')
      }
    },

    async removeFileFromAPI() {
      try {
        const removeResultList = await Promise.allSettled(
          this.deletedFilesForApi.map(file => fileApi.removeFile(file.id))
        )
        this.deletedFilesForApi = []
        if (removeResultList.some(el => el.status === 'rejected'))
          throw new Error(`Не удалось удалить все необходимые файлы`, { cause: 'Custom error' })
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, e.cause === 'Custom error' ? e.message : 'Не удалось удалить все необходимые файлы')
        throw new Error(`Ошибка удаления файлов`)
      }
    }
  }
}
